export const property = {
  gamefi: "Счёт GameFi",
  mc_official_verify_unofficial: "Неофициальный канал",
  mc_official_verify_official: "Официальный",
  mc_official_verify_fotter_tip_1:
    "Предупреждение о мошенничестве: остерегайтесь лиц, выдающих себя за сотрудников Biking (телефонные звонки, сообщения).",
  mc_official_verify_fotter_tip_2:
    "Официальное заявление: предупреждение о мошенниках, использующих имя Biking.",
  mc_official_verify_modal_tip_1:"【{query}】 подтверждён как официальный канал Biking",
  mc_official_verify_modal_tip_3: "Проверьте правильность введённых данных и формата:",
  mc_official_verify_modal_tip_4: "Номер телефона: xx-xxxxxxxxx",
  mc_official_verify_modal_type_email: "Эл. почта",
  mc_official_verify_modal_type_domain: "Веб-сайт",
  mc_official_verify_modal_type_channel: "Канал",
  mc_official_verify_input_placeholder: "Введите корректные данные для проверки",
  mc_official_verify_head_title: "Официальный канал верификации Biking | Biking",
  mc_official_verify_head_description: "Официальный канал верификации Biking",
  mc_official_verify_title: "Официальная верификация",
  mc_official_verify_discription_new:"Чтобы избежать потери средств из-за фишинга или мошенничества, проверяйте веб-сайты, email, номера телефонов, а также аккаунты в Twitter, Telegram и др. на предмет принадлежности к официальным каналам Biking.",
  mc_official_verify_fotter_tip_3:"Обязательно к прочтению: руководство по предотвращению мошенничества! Будьте бдительны!",
  mc_unofficial_verify_modal_tip_1:"【{query}】 не является официальным каналом Biking",
  mc_official_verify_discription:"Чтобы не стать жертвой мошенников, проверяйте через эту страницу, являются ли контакты (телефон, WeChat и т.д.) официальными каналами Biking.",
  mc_official_head_title1: "Верификация официальных каналов, новостей и публикаций Biking",
  mc_official_head_keywords1: "Верификация Biking, новости Biking, официальные аккаунты Biking",
  mc_official_head_description1:"Убедитесь в подлинности каналов Biking. Используйте наш официальный инструмент для проверки легитимности каналов, новостей и публикаций, связанных с Biking.",
  mc_official_verify_verified_title: "Официальные верифицированные каналы",
  mc_official_verify_modal_tip_5:"Telegram/X/Facebook/Youtube: @xxxxx (с @)",
  mc_official_verify_modal_tip_6: "TikTok/Instagram: xxxx (без @)",
  mc_official_verify_modal_tip_7: "Discord: xxxx#xxxx (без @)",
  mc_official_verify_modal_tip_8:"Linkedin/Telegram-группы/Medium/Reddit: https://xxxxx (ссылка)",
  mc_official_verify_modal_tip_9: "При сомнениях обращайтесь в онлайн-поддержку.",
  mc_official_verify_modal_tip_10: "*Никому не сообщайте данные своего аккаунта и пароль.",
  mc_official_verify_modal_tip_11:"*Будьте бдительны, остерегайтесь мошенничества.",
  tagtip: "Если платформа пополнения не требует указания Comment, поле можно оставить пустым.",
  tagtip1: "Tag — это уникальный код для идентификации аккаунта или пользователя, обеспечивающий отправку средств правильному получателю.",
  tagtip2: "Другие платформы или кошельки могут называть Tag: цифровой ID, Tag, Memo, Note, Remark,备注 и т.д.",
  tag: "Введите Comment",
  qbcbcg: "Скопируйте и адрес TON, и comment, чтобы гарантировать успешное пополнение.",
  qsrzqje: "Введите корректную сумму",
  games: "Игровой счёт",
  cbxz: "Правила пополнения Ethereum (ERC20)",
  tbxz: "Правила вывода Ethereum (ERC20)",
  ctbzysx: "Обратите внимание: каждый перевод по смарт-контракту FUFU взимает дополнительную комиссию 2%.",
  dzcw: "Неверный адрес",
  czqkqrs: "Подтверждения сети",
  mc: "Название",
  cjsj: "Время создания",
  lx: "Тип",
  sl: "Количество",
  cwjl: "Финансовые записи",

  ylzh: "Прибыль",
  ddtx: "Ожидание вывода",
  txcg: "Вывод успешен",
  yhcx: "Отменено пользователем",
  qbcbjl: "История пополнений",

  zczl: "Обзор активов",
  zjzh: "Аккаунт активов",
  mbzh: "Счёт для покупки (фиат)",
  xhzh: "Спот-счёт",
  hyzh: "Фьючерсный счёт",
  lczh: "Счёт управления капиталом",
  gdzh: "Счёт копитрейдинга",
  giftzh: "Бонусный счёт",
  bwzh: "Карта BiKing",
  mozh: "Демо-счёт",
  mnhy: "Демо-фьючерсы",
  sxffy: "Системный возврат комиссии",
  kt: "Эйрдроп",
  xtkc: "Списано системой",
  zcfb: "Распределение активов",
  zcdt: "Динамика активов",
  zh: "Счёт",
  zc: "Активы",
  czjl: "История пополнений",
  txls: "История выводов",
  hzjl: "История переводов",
  mmjl: "История покупок/продаж",
  cb: "Пополнить",
  tx: "Вывести",
  hz: "Перевести",
  mb: "Купить (фиат)",
  jy: "Торговать",
  zwsj: "Нет данных",
  ckqb: "Показать все",

  // table
  bz: "Монета",
  qc: "Полное название",
  zhze: "Баланс на счету",
  syzc: "Остаток",
  djzc: "Заморожено",
  cz: "Действие",
  sl: "Количество",
  cbdz: "Адрес пополнения",
  sj: "Время",
  zt: "Статус",
  ms: "Описание",
  hzfx: "Направление перевода",
  hzse: "Сумма перевода",
  txdz: "Адрес вывода",
  sxf: "Комиссия",
  ddh: "Номер ордера",
  zj: "Общая сумма",
  dj: "Цена за единицу",
  jysl: "Объём сделки",
  jydx: "Контрагент",
  zhqy: "Собственный капитал",
  zhqytips: "Капитал = Доступная маржа + Маржа позиций",
  kybzj: "Доступная маржа",
  kybzjtips: "Маржа, доступная для открытия позиций или перевода",
  cwbzj: "Маржа позиций",
  cwbzjtips: "Маржа, удерживаемая под открытыми позициями",

  // search
  srbz: "Введите монету",
  ycxzc: "Скрыть малые активы",
  sy: "Все",
  qb: "Все",
  qx: "Выбрать всё",
  zhi: "до",
  ksrq: "Начальная дата",
  jsrq: "Конечная дата",
  cx: "Поиск",
  dc: "Экспорт",
  zjqt: "Последние 7 дней",
  zjygy: "Последний месяц",
  qbsj: "За всё время",
  usdt: "USDT",
  ddlx: "Тип ордера",
  gm: "Покупка",
  cs: "Продажа",

  // recharge
  czxq: "Детали пополнения",
  usdtcbjl: "История пополнения {coinName}",
  cbsl: "Сумма пополнения",
  cbzt: "Статус пополнения",
  crdbz: "Выберите монету для пополнения",
  tqdbz: "Выберите монету для вывода",
  rmbz: "Популярные монеты",
  qxz: "Выберите",
  cbwl: "Сеть пополнения",
  cbtips: "Убедитесь, что вы выбрали ту же сеть, что и на платформе вывода. Иначе средства будут потеряны.",
  txfs: "Способ вывода",
  lstx: "Вывод в блокчейн",
  xyb: "Далее",
  yxzdq: "Выбрано",
  dbz: "монета",
  cxxz: "Выбрать заново",
  dzkbz: "Недостаточно адресов в адресной книге, свяжитесь с администратором.",
  qxzcrdbz: "Сначала выберите монету для пополнения",
  qxzcbwl: "Выберите сеть для пополнения",
  qxztqdbz: "Сначала выберите монету для вывода",
  cr: "Пополнить",
  tq: "Вывести",
  cbxq: "Детали пополнения",
  txxq: "Детали вывода",
  usdttxjl: "История выводов {coinName}",
  qbtxjl: "История всех выводов",
  zyxx: "Важно: отправляйте на этот адрес только {coinName}. Отправка других цифровых валют приведёт к потере средств.",
  jzjcr: "Пополнить средства",
  smewm: "Отсканируйте QR-код или скопируйте информацию ниже",
  xcdzcz: "Пополнение не того типа монет приведёт к невозвратной потере активов",
  xcdzczss: "При пополнении XRP обязательно скопируйте tag, иначе средства могут быть потеряны.",
  znhycz: "Смарт-контракты, пакетные пополнения и вознаграждения за блоки не поддерживаются.",
  usdtcbdz: "Адрес для пополнения {coinName}",
  fzdz: "Копировать адрес",
  usdtdz: "Адрес {coinName}",
  zxcbe: "Мин. сумма пополнения",
  zytx2:
    "Важно: убедитесь, что принимающая платформа поддерживает выбранную вами сеть {coinName}, иначе средства будут потеряны.",
  kytxwl: "Доступные сети для вывода {coinName}",
  xzwl: "Выберите сеть",
  dzym: "Адрес {coinName}",
  srdz: "Введите адрес или выберите из адресной книги",
  jymm: "Торговый пароль",
  qsrjymm: "Введите торговый пароль",
  zxtbe: "Мин. сумма вывода: {minAmount}",
  ky: "Доступно:",
  zhztbxe: "Лимит вывода на аккаунт",
  gjxyddj:
    "В зависимости от уровня верификации ваш суточный лимит вывода ограничен. Лимит конвертируется из USD в выбранную монету.",
  scbdjd:
    "Из-за волатильности цены комиссия за вывод плавающая. Средняя базовая комиссия: 0,2–0,2 USDT в эквиваленте за последние 24 часа. Можно увеличить комиссию для ускорения.",
  yqdz: "Ожидаемое поступление",
  yqdzwf: "Ожидаемое поступление не может быть отрицательным",
  sfrz: "Верификация",
  ggyzm: "Код Google Authenticator",
  dxyzm: "СМС-код",
  yxyzm: "Код из email",
  qsryzm: "Введите код подтверждения",
  fsyzm: "Отправить код",
  cxfs: "Отправить повторно",
  tj: "Отправить",
  qxztxwl: "Выберите сеть для вывода",
  qsrdz: "Введите адрес",

  qxzdz: "Выберите адрес",
  qxzyzfs: "Выберите способ верификации",
  qsrtqsl: "Введите сумму вывода",
  qwcyz: "Завершите проверку",
  qqrbdsj: "Подтвердите привязку телефона",
  qqrbdyx: "Подтвердите привязку email",
  fzcg: "Скопировано!",
  tbcg: "Вывод выполнен",
  usdttxdz: "Адрес для вывода {coinName}",
  lmc: "Название сети:",
  qtj: "*Пожалуйста, укажите",
  dz: "адрес",
  fei: "Не-",
  zjds: "адрес может привести к потере активов",
  yzfs: "Способ верификации",
  yzm: "Код подтверждения",
  remark: "Примечание",
  qsrremark: "Введите примечание",
  tjdzcg: "Адрес успешно добавлен",
  qxxzyzfs: "Сначала выберите способ верификации",
  qsrtxdz: "Введите адрес вывода",
  
  stop: "Остановлено",

  // status
  qr0: "0 подтверждений",
  qr1: "1 подтверждение",
  dqr: "Ожидание подтверждения",
  czcg: "Пополнение успешно",
  hzz: "Перевод в процессе",
  ywc: "Завершено",
  sb: "Ошибка",
  zzcl: "В обработке",
  ddsh: "Ожидает проверки",
  txcg: "Вывод успешен",
  cxcg: "Отмена успешна",
  ddtx: "Ожидание вывода",
  txsb: "Ошибка вывода",
  slsb: "Ошибка отправки в сеть",
  dfk: "Ожидает оплаты",
  yfk: "Оплачено",
  yqx: "Отменено",
  ssz: "В процессе разрешения спора",
  gdfrhz: "Перевод доли от копитрейдинга",
  hyzh_to_gdzh: "Фьючерсный счёт → Счёт копитрейдинга",
  gdzh_to_hyzh: "Счёт копитрейдинга → Фьючерсный счёт",
  ddcl: "Ожидает обработки",
  cg: "Успешно",

  // dialog
  zchz: "Перевод активов",
  ljhz: "Перевести",
  cong: "С",
  dao: "На",
  qtzh: "Другой счёт",
  qxzbz: "Выберите монету",
  qsrsl: "Введите количество",
  khz: "Доступно для перевода:",
  ye: "Баланс:",
  hzcg: "Перевод выполнен",

  // h5
  zcgl: "Обзор активов",
  xrzx: "Бонус для новичков",
  zzc: "Общие активы",
  jryk: "P&L за сегодня",
  zgjz: "Новый набор до 3200 USDT ждёт вас!",
  zhrj: "Пополните счёт",
  xzrjfs: "После пополнения вы сможете купить криптовалюту. Выберите удобный способ:",
  czszhb: "Пополнить криптовалюту",
  yyydszhb: "Внесите криптовалюту с другой платформы или кошелька на счёт Biking.",
  czfb: "Пополнить фиат",
  czzhz:
    "Внесите фиатные деньги на счёт Biking (банковская карта, перевод и т.д.)",
  maibi: "Купить криптовалюту",
  tgdsfmb: "Купить криптовалюту через банковскую карту, P2P, сторонние сервисы",
  yqyl: "Приглашайте и получайте",
  yqfy: "20% комиссии с друзей",
  cxzzn: "Руководство для начинающих",
  czzh: "Создайте аккаунт Biking",
  hdxrj: "Получите 100 USDT бонуса для новичков",
  ck: "Депозит",
  tzndzh: "Инвестируйте в свой аккаунт и начните путь, поддерживается множество способов оплаты",
  wcsfrz: "Пройдите верификацию (KYC)",
  hgzh: "Пройдите KYC и станьте верифицированным пользователем",
  ksjy: "Начните торговать",
  tsgd: "Продавайте, покупайте или копируйте сделки — исследуйте возможности",
  ksndlc: "Начните своё путешествие",
  kjydjmhb: "Доступные криптовалюты",
  jmhb: "Капитализация рынка: $1 228 485 млн",
  zengjin: "Бонус",
  lc: "Финансовые продукты",
  mb: "Купить (фиат)",
  lsjl: "История",
  zclb: "Список активов",
  shaixuan: "Фильтр",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/property/ru.js